import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export default {
  install: (app) => {
    // Make gsap available as a global property
    app.config.globalProperties.$gsap = gsap;
    app.config.globalProperties.$ScrollTrigger = ScrollTrigger;

    // Also provide access via provide/inject
    app.provide("gsap", gsap);
    app.provide("ScrollTrigger", ScrollTrigger);
  },
};
